<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>Sổ tay Doanh nghiệp Thành viên － Chương Hệ thống<!--會員事業手冊－制度篇--></h1>
        </div>
      </header>
      <HeaderNav activeLink="membershipSystem" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Một．Mọi người sẽ<!--壹．人會--></h2>
            <p>
              Trong Fudizi Business, bạn có thể chọn trở thành người tiêu dùng, người điều hành và người lãnh đạo. Do đó, ngay từ khi bắt đầu trở thành thành viên, 
              bạn có thể chọn các cách tham gia sau.
              <!--富地滋事業，可以任由遞擇成為消費者、經營者與領導人，因而從加入會員開始，就可以選擇以下幾種方式入會。-->
            </p>

            <br/><br/><br/>

            <h4>Thành viên C (người dùng)<!--C 會員(愛用者)--></h4>
            <p>
              Tư cách thành viên chỉ dành riêng cho thành viên. Loại thành viên này sẽ hủy bỏ hệ thống tiêu thụ tự động và chuyển ra khỏi cơ cấu tổ chức thành viên. Không có tiền thưởng
              <!--僅供會員保留會員資格。此會員種類會取消自動消費系統並移出會員組織架構．無獎金-->
            </p>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên A<!--A 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>Khi tham gia tư cách thành viên, bạn phải mua một chai sản phẩm axit nucleic trong 2 tháng đầu tiên và hàng tháng để hoàn thành tư cách thành viên.
                        <!--入會時首購2個月，每個月1瓶核酸產品，才算完成入會資格--></li>
                    <li>Để duy trì tư cách thành viên A, bạn cần mua 1 chai sản phẩm axit nucleic mỗi tháng<!--維持A會員資格每個月需購買1瓶核酸產品--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên A<!--辦理自動消費系統以維持A會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                  </lu>            
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên B<!--B 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia tư cách thành viên, trước tiên bạn phải mua 2 chai sản phẩm axit nucleic trong 2 tháng và hàng tháng để hoàn thành tư cách thành viên.
                      <!--入會時首購2個月，每個月2瓶核酸產品，才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên B, bạn cần mua 2 chai sản phẩm axit nucleic mỗi tháng<!--維持B會員資格每個月需購買2瓶核酸產--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên B<!--辦理自動消費系統以維持B會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Cứ sau 2 tháng liên tục mua thường xuyên 10.000PV sẽ được tặng 1 chai DN Collagen Nucleic Acid 720ML.<!--每連續2個月定期購買10000PV後可獲贈1瓶DN膠原核酸720ML--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Tiền thưởng cho người hướng dẫn (tiền thưởng định kỳ)<!--指導員獎金（循環獎金）--></li>
                    <li>Tiền thưởng sao (tiền thưởng định kỳ)<!--星級獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                    <li>Tiền thưởng đội ngũ tuyển dụng<!--聘階團隊獎金--></li>
                    <li>Tiền thưởng tuyển dụng thành viên<!--同聘階獎金--></li>
                  </lu>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên E<!--E 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia tư cách thành viên, bạn phải mua 2 hộp lần đầu tiên trong 2 tháng và 2 hộp (túi xách tay Fudi Zi LOHAS) mỗi tháng để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月2盒（富地滋樂活隨身包），才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên E, bạn cần mua 2 hộp (túi xách tay Fudi Zi LOHAS) mỗi tháng<!--維持E會員資格每個月需購買2盒（富地滋樂活隨身包）--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên E<!--辦理自動消費系統以維持E會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                  </lu>  
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên F<!--F 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia tư cách thành viên, trước tiên bạn phải mua 2 tháng và 4 hộp (túi xách tay Fudi Zi LOHAS) mỗi tháng để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月4盒（富地滋樂活隨身包），才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên F, bạn cần mua 4 hộp (túi xách tay Fudi Zi LOHAS) mỗi tháng<!--維持F會員資格每個月需購買4盒（富地滋樂活隨身包）--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên F<!--辦理自動消費系統以維持F會員資格--></li>
                  </lu>  
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Cứ sau 2 tháng liên tục mua thường xuyên 10.000PV sẽ được tặng 1 chai DN Collagen Nucleic Acid 720ML.<!--每連續2個月定期購買10000PV後可獲贈1瓶DN膠原核酸720ML--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Tiền thưởng cho người hướng dẫn (tiền thưởng định kỳ)<!--指導員獎金（循環獎金）--></li>
                    <li>Tiền thưởng sao (tiền thưởng định kỳ)<!--星級獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                    <li>Tiền thưởng đội ngũ tuyển dụng<!--聘階團隊獎金--></li>
                    <li>Tiền thưởng tuyển dụng thành viên<!--同聘階獎金--></li>
                  </lu>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên SA<!--SA 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia tư cách thành viên, trước tiên bạn phải mua 2 hộp Nước uống Collagen Mengsha ED trong 2 tháng mỗi tháng để hoàn thành tư cách thành viên.
                      <!--入會時首購2個月，每個月2盒（夢莎ED膠原蛋白飲），才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên SA, bạn cần mua 2 hộp (Nước uống Collagen Mengsha ED) mỗi tháng<!--維持SA會員資格每個月需購買2盒（夢莎ED膠原蛋白飲）--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên SA<!--辦理自動消費系統以維持SA會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                  </lu>  
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên SB<!--SB 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia tư cách thành viên, trước tiên bạn phải mua 2 tháng và 4 hộp (Nước uống Collagen Mạnhsha ED) mỗi tháng để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月4盒（夢莎ED膠原蛋白飲），才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên SB, bạn cần mua 4 hộp (Nước uống Collagen Mạnhsha ED) mỗi tháng<!--維持SB會員資格每個月需購買4盒（夢莎ED膠原蛋白飲）--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên SB<!--辦理自動消費系統以維持SB會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Cứ sau 2 tháng liên tục mua thường xuyên 10.000PV sẽ được tặng 1 chai DN Collagen Nucleic Acid 720ML.<!--每連續2個月定期購買10000PV後可獲贈1瓶DN膠原核酸720ML--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Tiền thưởng cho người hướng dẫn (tiền thưởng định kỳ)<!--指導員獎金（循環獎金）--></li>
                    <li>Tiền thưởng sao (tiền thưởng định kỳ)<!--星級獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                    <li>Tiền thưởng đội ngũ tuyển dụng<!--聘階團隊獎金--></li>
                    <li>Tiền thưởng tuyển dụng thành viên<!--同聘階獎金--></li>
                  </lu>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên MA<!--MA 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia thành viên, lần mua đầu tiên là 2 tháng và cần 4.000 nhân dân tệ mỗi tháng (loạt tác động kép ngược thời gian của Mengsha hoặc các sản phẩm LU) để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月需購買4000元（夢莎逆時雙效系列或LU商品），才算完成入會資格-->
                    </li>
                    <li>
                      Để duy trì tư cách thành viên MA, bạn cần mua 4.000 nhân dân tệ mỗi tháng (loạt tác động kép ngược thời gian của Mengsha hoặc các sản phẩm LU)
                      <!--維持MA會員資格每個月需購買4000元（夢莎逆時雙效系列或LU商品）-->
                    </li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên MA<!--辦理自動消費系統以維持MA會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                  </lu>  
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên MB<!--MB 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia thành viên, lần mua đầu tiên là 2 tháng và bạn cần mua 8.000 nhân dân tệ mỗi tháng (loạt tác động kép ngược thời gian của Mengsa hoặc các sản phẩm LU) để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月需購買8000元（夢莎逆時雙效系列或LU商品），才算完成入會資格-->
                    </li>
                    <li>
                      Để duy trì tư cách thành viên MB, bạn cần mua 8.000 nhân dân tệ mỗi tháng (loạt tác động kép ngược thời gian của Mengsha hoặc các sản phẩm LU)
                      <!--維持MB會員資格每個月需購買8000元（夢莎逆時雙效系列或LU商品）-->
                    </li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên MB<!--辦理自動消費系統以維持MB會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Cứ sau 2 tháng liên tục mua thường xuyên 10.000PV sẽ được tặng 1 chai DN Collagen Nucleic Acid 720ML.<!--每連續2個月定期購買10000PV後可獲贈1瓶DN膠原核酸720ML--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Tiền thưởng cho người hướng dẫn (tiền thưởng định kỳ)<!--指導員獎金（循環獎金）--></li>
                    <li>Tiền thưởng sao (tiền thưởng định kỳ)<!--星級獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                    <li>Tiền thưởng đội ngũ tuyển dụng<!--聘階團隊獎金--></li>
                    <li>Tiền thưởng tuyển dụng thành viên<!--同聘階獎金--></li>
                  </lu>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên HA<!--HA 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia thành viên, bạn phải mua 2 chai lần đầu tiên trong 2 tháng và 2 chai mỗi tháng (titan quang hợp được trồng ở Disengeng) để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月2瓶（光合鈦在地森耕），才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên HA, bạn cần mua 2 chai mỗi tháng (titan quang hợp được trồng ở Disengeng)<!--維持HA會員資格每個月需購買2瓶（光合鈦在地森耕）--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên HA<!--辦理自動消費系統以維持HA會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                  </lu>  
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h4>Thành viên HB<!--HB 會員--></h4>
            <table class="manufactoring-table">
              <tr>
                <th>Đủ điều kiện<!--取得資格--></th>
                <td>
                  <lu>
                    <li>Phí thành viên NT 700 Đài tệ<!--入會費NT700元--></li>
                    <li>
                      Khi tham gia thành viên, bạn phải mua 2 chai lần đầu tiên trong 2 tháng và 4 chai mỗi tháng (titan quang hợp được trồng ở Disengeng) để hoàn thành tư cách thành viên
                      <!--入會時首購2個月，每個月4瓶（光合鈦在地森耕），才算完成入會資格-->
                    </li>
                    <li>Để duy trì tư cách thành viên HB, bạn cần mua 4 chai mỗi tháng (titan quang hợp được trồng ở Disengeng)<!--維持HB會員資格每個月需購買4瓶（光合鈦在地森耕）--></li>
                    <li>Đăng ký hệ thống tiêu thụ tự động để duy trì tư cách thành viên HB<!--辦理自動消費系統以維持HB會員資格--></li>
                  </lu>
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng phúc lợi<!--福利獎金--></th>
                <td>
                  <lu>
                    <li>Có quyền giới thiệu và vận hành<!--擁有推薦經營權--></li>
                    <li>Cứ sau 2 tháng liên tục mua thường xuyên 10.000PV sẽ được tặng 1 chai DN Collagen Nucleic Acid 720ML.<!--每連續2個月定期購買10000PV後可獲贈1瓶DN膠原核酸720ML--></li>
                    <li>Tiền thưởng giới thiệu<!--推薦獎金--></li>
                    <li>Tiền thưởng huấn luyện viên<!--培訓員獎金--></li>
                    <li>Tiền thưởng theo cấp (Tiền thưởng đi xe đạp)<!--層數獎金（循環獎金）--></li>
                    <li>Tiền thưởng cho người hướng dẫn (tiền thưởng định kỳ)<!--指導員獎金（循環獎金）--></li>
                    <li>Tiền thưởng sao (tiền thưởng định kỳ)<!--星級獎金（循環獎金）--></li>
                    <li>Đơn hàng bổ sung (siêu thưởng)<!--追加訂購（超頵獎金）--></li> 
                    <li>Tiền thưởng đội ngũ tuyển dụng<!--聘階團隊獎金--></li>
                    <li>Tiền thưởng tuyển dụng thành viên<!--同聘階獎金--></li>
                  </lu>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Hai．Quy tắc kinh doanh<!--貳．經營規則--></h2>
            <h2 class="section-title">【 1. Biện pháp phòng ngừa khi vận hành 】<!--【一、經營注意事項 】--></h2>
            <div>
              <table>
                <tr>
                  <td width="5%"></td>
                  <td>
                    <lu>
                      <li>Thành viên mới có thể được bố trí ở bất cứ đâu trong tổ chức bảo trợ.<!--可以安置新會員於傘下組織內任何位置。--></li>
                      <li>
                        Cấp độ thành viên đầu tiên không vượt quá tối đa 7 thành viên offline trực tiếp B (giới hạn này không áp dụng nếu có nhiều hơn 7 thành viên offline trực tiếp B do điều kiện thắt chặt).
                        <!--第一層會員最多不得超過7位直B下線（緊縮情況造成超過7位直B下線不在此限）。-->
                      </li>
                      <li>
                        Cùng một tên có thể có nhiều quyền điều hành cùng một lúc, nhưng số lượng tối đa không vượt quá 10. Tuy nhiên, điều này không áp 
                        dụng cho những người có cùng tên đang điền vào cấu trúc trình độ chuyên môn của người hướng dẫn (DR) cùng một lúc. Phương thức 
                        để có được quyền quản lý cũng giống như việc tham gia thành viên.
                        <!--同一名稱可同時擁有多個經營權，但至多不得超過1 0個，但如同一名稱，一次補足指導員資格(DR)架構者，不在此限。且取得經營權之方式與入會方式同。-->
                      </li>
                    </lu>
                  </td>
                </tr>
              </table>
            </div>
            <br/><br/><br/>
            <h2 class="section-title">【 2. Phương thức thay đổi tư cách thành viên 】<!--【二、會員變更辦法 】--></h2>
            <div>
              <table>
                <tr>
                  <td width="5%"></td>
                  <td>
                    <lu>
                      <li>
                        Để thay đổi tư cách thành viên, phải nộp đơn đăng ký bằng văn bản cho công ty và việc thay đổi chỉ có thể được thực hiện sau khi được công ty chấp thuận.
                        <!--變更會員須向公司提出書面申請，經公司認可後始可變更。-->
                      </li>
                      <li>
                        Những người thay đổi từ tư cách thành viên C sang tư cách thành viên A/B/E/F/SA/SB/MA/MB/NA/NB/HA/HB phải đăng ký lại.
                        <!--由C會員變更為A/B/E/F/SA/SB/MA/MB/NA/NB/HA/HB會員者必須再次登記。-->
                      </li>
                      <li>
                        Đơn xin chuyển đổi thành viên A/B/E/F/SA/SB/MA/MB/HA/HB sang thành viên C hoặc chuyển đổi lẫn nhau A/B/E/F/SA/SB/MA/MB/HA/HB tư cách thành viên phải được thực hiện tại Nó sẽ có hiệu lực vào tháng tiếp theo.
                        <!--A/B/E/F/SA/SB/MA/MB/HA/HB會員變更C會員或A/B/E/F/SA/SB/MA/MB/HA/HB會員相互變更之申請需於次月開始生效。-->
                      </li>
                      <li>Không có đơn xin thay đổi nào có thể được thực hiện trong vòng hai tháng kể từ khi hoàn tất đăng ký thành viên.<!--入會登錄完成兩個月內不得申請變更。--></li>
                    </lu>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </section>

      </section>
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/productHeaderNav";
export default {
  name: "MembershipSystemScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  .public-page
    .manufactoring-table
    th:not(.td-bg-middle-dark):not(.td-bg-dark) {
    width: 120px;
  }
}
</style>
